import React, { FC } from 'react'
import { ICellRendererParams } from 'ag-grid-community'
import styled from '@emotion/styled'
import { iconSet } from './icons/axeRollUnwindIconSet'
import { TradeConditionFlag } from 'api/generated'
import { AxeTradeCondition } from 'api'

interface AxeRollUnwindSummaryProps extends ICellRendererParams {
  value: CounterypartyTradeCondition[]
}

interface CounterypartyTradeCondition extends AxeTradeCondition {
  publishedName: string
  isAxed: boolean
  tradeCondition: TradeConditionFlag
}

const Container = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const CounterpartyContainer = styled.span`
  margin-right: 20px;
`

const Icon = styled.span`
  position: relative;
  top: 20%;
`

export const AxeRollUnwindSummaryComponent: FC<AxeRollUnwindSummaryProps> = props => {
  const counterpartyConditionArr = props.value

  const renderCounterparty = (counterparty: CounterypartyTradeCondition) => {
    const { isAxed, publishedName, tradeCondition } = counterparty

    if (tradeCondition === 'NONE' && !isAxed) {
      return
    }

    return (
      <CounterpartyContainer key={publishedName}>
        {isAxed && <Icon>{iconSet.axe}</Icon>}
        {tradeCondition === TradeConditionFlag.ROLL && <Icon>{iconSet.roll}</Icon>}
        {tradeCondition === TradeConditionFlag.UNWIND && <Icon>{iconSet.unwind}</Icon>}
        {tradeCondition === TradeConditionFlag.SUB && <Icon>{iconSet.sub}</Icon>}
        {publishedName}
      </CounterpartyContainer>
    )
  }

  return <Container>{counterpartyConditionArr.map(renderCounterparty)}</Container>
}
